import { render, staticRenderFns } from "./SsbSetupEdit.vue?vue&type=template&id=7dc1709b"
import script from "./SsbSetupEdit.vue?vue&type=script&lang=js"
export * from "./SsbSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports